import { ele, TalkerAPI } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageProjectSettings
{
    constructor(targetElement)
    {
        const patchId = targetElement.dataset.patchId;
        const shortId = targetElement.dataset.shortId;

        this._iframe = targetElement.dataset.iframe;

        this._id = patchId;
        this._shortId = shortId;

        this._talkerAPI = null;
        if (this._iframe)
        {
            this._talkerAPI = new TalkerAPI(window.parent);
            this._talkerAPI.addEventListener("screenshotSaved", () =>
            {
                setTimeout(() =>
                {
                    if (document.getElementById("screenshotsavebutton"))
                    {
                        document.getElementById("screenshotsavebutton").style.display = "block";
                        document.getElementById("screenshotsaveloading").style.display = "none";
                        document.getElementById("patchscreenshot").src = "/thumb/hq/" + patchId + "/thumb.webp?rnd=" + Math.random();
                    }
                }, 500);
            });
        }

        this._licences = [
            "cc-by",
            "cc-by-sa",
            "cc-by-nd",
            "cc-by-nc",
            "cc-by-nc-sa",
            "cc-by-nc-nd",
            "cc0",
            "none",
            "copyright"
        ];

        const infoTab = document.getElementById("tab_info");
        const basicsTab = document.getElementById("tab_basics");
        const userTab = document.getElementById("tab_users");

        if (infoTab)
        {
            api.get("projectinfo/" + this._shortId, (res) =>
            {
                const project = res.data.info.project;
                const user = res.data.info.user;
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": user, "displayedDate": "updated" });
                web.setHandleBarHtml("project", { "project": project, "projectInfo": projectInfo }, infoTab);
            }, () => {});
        }

        if (basicsTab)
        {
            const autoSuggestTags = basicsTab.querySelectorAll("#settings_tags");
            const autoSuggestNamespace = basicsTab.querySelectorAll("#settings_namespace");
            web.initializeAutosuggestsFromApi(autoSuggestTags, { "append": true, "minLength": 3 });
            web.initializeAutosuggestsFromApi(autoSuggestNamespace);
        }

        if (userTab)
        {
            const autoSuggests = userTab.querySelectorAll("[data-autosuggest]");
            web.initializeAutosuggestsFromApi(autoSuggests);
        }

        const tabs = ele.byQueryAll("ul.tab-bar li");
        tabs.forEach((t) =>
        {
            t.addEventListener("activated", () =>
            {
                this.show(t);
            });
        });
    }

    delete(button)
    {
        web.buttons.startSavingAnimButton(button);
        const patchId = this._id;
        if (this._talkerAPI) this._talkerAPI.send("setSavedState", { "state": true });

        api.delete("project/" + patchId, {}, () =>
        {
            web.buttons.stopSavingAnimButton(button);
            if (window.top)
            {
                window.top.location.href = "/mypatches";
                return false;
            }
            else
            {
                document.location.href = "/mypatches";
                return false;
            }
        }, (err) =>
        {
            web.buttons.stopSavingAnimButton(button, true, true);
            console.error("failed to delete patch", err);
        });
    }

    showError(errors)
    {
        let msg = "";
        for (let i = 0; i < errors.length; i++)
        {
            msg += "<li>" + errors[i] + "</li>";
        }
        let html = "<ul>" + msg + "</ul>";

        const errorEle = ele.byId("errors");
        if (errorEle)
        {
            errorEle.innerHTML = html;
            ele.show(errorEle);
        }
    }

    _saveSettings(data, options)
    {
        options = options || {};

        api.put(
            "patch/settings/" + this._id,
            {
                "data": data,
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                if (!res.success)
                {
                    if (res.msg === "CANNOT_PUBLISH")
                    {
                        if (options.cbSuccess)
                        {
                            options.cbSuccess(res.data);
                        }
                    }

                    if (options.cbFail) options.cbFail(res);
                    this.showError(res.data.errors);
                    window.scrollTo(0, 0);
                }
                else
                {
                    ele.hide(ele.byId("errors"));
                    if (res.data && res.data.visibility)
                    {
                        const visibilityInfos = ele.byQueryAll(".highlightBlock.visibility");
                        visibilityInfos.forEach((visibilityInfo) => { ele.hide(visibilityInfo); });
                        const newVisibilityInfo = ele.byQuery(".highlightBlock.visibility." + res.data.visibility);
                        if (newVisibilityInfo) ele.show(newVisibilityInfo);
                        if (options.cbSuccess) options.cbSuccess(res);
                    }
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                ele.byId("settingssavebutton").innerText = "something went wrong: " + res.msg;
            }
        );
    }

    setLicence(licence, visibility)
    {
        if (visibility === "public" && licence === "none")
        {
            return this.showError(["unable to remove licence from public patch"]);
        }
        if (!this._licences.includes(licence)) return this.showError(["unknown licence"]);

        ele.byQueryAll(".radiodiv").forEach((e) =>
        {
            e.classList.remove("radiodiv_checked");
        });

        ele.byId("patch-licence-" + licence).classList.add("radiodiv_checked");

        this._saveSettings({ "licence": licence }, { "cbSuccess": () => {} });
    }

    toggleManualScreenshot(ids)
    {
        api.put("patch/settings/" + this._id + "/toggleScreenshot/", {}, (r) =>
        {
            if (this._talkerAPI) this._talkerAPI.send("manualScreenshot", { "manualScreenshot": r.manualScreenshot });
            document.location.reload();
        });
    }

    createScreenshot(ids)
    {
        if (this._talkerAPI) this._talkerAPI.send("manualScreenshot", { "manualScreenshot": true });

        const saveButton = document.getElementById("screenshotsavebutton");
        if (saveButton) saveButton.style.display = "none";
        const saveLoading = document.getElementById("screenshotsaveloading");
        if (saveLoading) saveLoading.style.display = "block";
    }

    updateSetting(ids, doScreenshotOnSuccess = false)
    {
        let data = {};

        for (let i = 0; i < ids.length; i++)
        {
            const id = ids[i];
            const prop = ele.byId(id).dataset.property;
            let v = ele.byId(id).value;

            if (ele.byId(id).getAttribute("type") === "checkbox") v = document.getElementById(id).checked;
            data[prop] = v;
        }

        this._saveSettings(data,
            {
                "cbSuccess": (res) =>
                {
                    if (this._talkerAPI)
                    {
                        this._talkerAPI.send("notify", { "msg": "Settings Saved" });
                        if (res && res.data && res.data.summary) this._talkerAPI.send("updatePatchSummary", res.data.summary);
                        if (data.hasOwnProperty("name")) this._talkerAPI.send("updatePatchName", { "name": data.name });
                        if (doScreenshotOnSuccess)
                        {
                            this._talkerAPI.createScreenshot();
                        }
                    }
                }
            });
    }

    removeUser(uid)
    {
        api.delete("project/" + this._id + "/user/" + uid, {}, () =>
        {
            document.location.reload();
        });
    }

    makeOwner(uid)
    {
        api.put("project/" + this._id + "/owner/" + uid, {}, () =>
        {
            document.location.reload();
        });
    }

    addUser(username)
    {
        if (username.length < 2) return this.showError(["username to short"]);
        api.put("project/" + this._id + "/username/" + username, {}, () =>
        {
            document.location.reload();
        }, () =>
        {
            this.showError(["Username unknown"]);
        });
    }

    inviteUser(username, fullAccess = "true")
    {
        let readOnly = (fullAccess !== "true");
        if (username.length < 2) return this.showError(["username to short"]);
        api.put("patchinvite/" + this._id + "/username/" + username, { "readOnly": readOnly }, () =>
        {
            web.buttons.stopSavingAnimButton();
            document.location.reload();
        }, (error) =>
        {
            web.buttons.stopSavingAnimButton();
            let errorString = "invitation not possible";
            if (error.msg)
            {
                errorString += ": \"" + error.msg + "\"";
            }
            this.showError([errorString]);
        });
    }

    revokeInvitation(invitationId)
    {
        api.delete("patchinvite/" + invitationId, {}, () =>
        {
            web.buttons.stopSavingAnimButton();
            document.location.reload();
        }, (error) =>
        {
            web.buttons.stopSavingAnimButton();
            let errorString = "revocation not possible";
            if (error.msg)
            {
                errorString += ": \"" + error.msg + "\"";
            }
            this.showError([errorString]);
        });
    }

    addTeam(teamId)
    {
        if (teamId)
        {
            api.post("teams/" + teamId + "/projects/" + this._id, {}, (response) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton();
                this.showError(["Error adding team: " + e.msg]);
            });
        }
        else
        {
            web.buttons.stopSavingAnimButton();
            this.showError(["Unknown team or insufficient permissions"]);
        }
    }

    removeTeam(teamId)
    {
        const url = "teams/" + teamId + "/projects/" + this._id;
        api.delete(url, {}, () =>
        {
            document.location.reload();
        }, (e) =>
        {
            this.showError(["error removing team: " + e.msg]);
        });
    }

    show(tabEle, fromUserInteraction = false)
    {
        ele.hide(ele.byId("errors"));
        const tab = tabEle.dataset.tabName;
        if (tab === "delete")
        {
            const opDepsContainer = ele.byId("opdependencies");
            const patchDepsContainer = ele.byId("patchdependencies");

            const containerEle = ele.byId("tab_delete");
            const headline = containerEle.querySelector(".text");
            headline.innerText = "Delete";
            ele.hide(opDepsContainer);
            ele.hide(patchDepsContainer);
            ele.hide(ele.byId("deletepatch"));

            const loadingEle = containerEle.querySelector(".checkDelete");
            const confirmEle = ele.byId("deletepatch");
            const checkError = confirmEle.querySelector(".checkDepsError");
            ele.hide(checkError);

            if (loadingEle) ele.show(loadingEle);
            const doneCallback = (err, result) =>
            {
                if (loadingEle) ele.hide(loadingEle);

                let deps = {};
                if (!err && result)
                {
                    deps = result.data;
                }
                else
                {
                    ele.show(checkError);
                }

                let allowDelete = true;
                if (deps.ops > 0 || deps.projects > 1)
                {
                    const opDeps = opDepsContainer.querySelector(".ops");
                    ele.show(opDeps);
                    let html = "Assets of this patch are used in ";
                    if (deps.projects > 1)
                    {
                        html += (deps.projects - 1) + " other patch";
                        if (deps.projects > 2) html += "es";
                        if (deps.ops > 0) html += " and ";
                    }
                    if (deps.ops > 0)
                    {
                        html += (deps.ops) + " op";
                        if (deps.ops > 1) html += "s";
                    }
                    html += "! Check them before deleting the patch:<br/><br/><ul>";
                    deps.usedAssets.forEach((usedAsset) =>
                    {
                        html += "<li><a href='/asset/patches/?filename=/assets/" + this._id + "/" + usedAsset + "'>" + usedAsset + "</a></li>";
                    });
                    html += "</ul>";
                    opDeps.querySelector(".text").innerHTML = html;
                    allowDelete = deps.ops < 1;
                    ele.show(opDepsContainer);
                    window.scrollTo(0, 0);
                }
                if (allowDelete)
                {
                    ele.show(confirmEle);
                }
                else
                {
                    headline.innerText = "Patch cannot be deleted!";
                    ele.hide(confirmEle);
                }
            };
            api.get("assets/dependencies/count/" + this._id, (result) =>
            {
                doneCallback(null, result);
            }, (e) =>
            {
                doneCallback(e, null);
            });
        }
    }

    setPatchPermissions(value, userId, cb = false)
    {
        let fullAccess = (value === "fullAccess");
        api.put("project/" + this._id + "/" + userId + "/permissions/write/" + fullAccess, {}, () =>
        {
            if (cb) cb();
            else document.location.reload();
        });
    }

    getBackupsTable(targetElement)
    {
        web.projects.getBackupsTable("project/" + this._id + "/backups", targetElement, false, "bottom");
    }

    requestPatchAccess(projectId, permission = "read")
    {
        web.projects.requestAccess(projectId, permission, (result) =>
        {
            ele.hide(ele.byId("request-access-button"));
            ele.show(ele.byId("request-pending-text"));
        });
    }

}
